import { render, staticRenderFns } from "./TheSelectedQuote.vue?vue&type=template&id=ab203276&scoped=true&"
import script from "./TheSelectedQuote.vue?vue&type=script&lang=js&"
export * from "./TheSelectedQuote.vue?vue&type=script&lang=js&"
import style0 from "./TheSelectedQuote.vue?vue&type=style&index=0&id=ab203276&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab203276",
  null
  
)

export default component.exports